import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcNext = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M10.76 8.35 17.316 16l-6.558 7.65-1.518-1.3 5.441-6.351-5.441-6.348z" />
      <path d="M16.76 8.35 23.316 16l-6.558 7.65-1.518-1.3 5.441-6.351-5.441-6.348z" />
      <path d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2Zm0 2C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Z" />
    </g>
  </svg>
);
export default SvgIcNext;
